
import React from 'react'

export default (config = {}) => {

  return {
  };
};
